/** 사이트 이름과 설명. */


export const siteConfig = {
  name: "ZIPLINE-CMS",
  description: "Make beautiful websites regardless of your design experience.",
};
